import React from 'react';
import BottomBar from './BottomBar';
const Foreground = ({
  accent_color,
  accent_text_color,
  logo,
  metadata
}) => {
  const hide_poweredbyshift = metadata.hide_poweredbyshift;
  return /*#__PURE__*/React.createElement("div", {
    className: "Foreground"
  }, logo && /*#__PURE__*/React.createElement("img", {
    src: logo,
    className: "logo",
    alt: "logo"
  }), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: accent_text_color,
    hide_poweredbyshift: hide_poweredbyshift
  }));
};
export default Foreground;